import config from 'config';


/**
 * Log - Log to the console, with some prefixing
 *
 * @param  {*} ...str serie of objects which need to be logged
 * @return {Void}
 */
export default function log (...str) {
    const prefix = time() + ' - ' + config.logPrefix;

    console.info('%c' + prefix, 'color: grey; font-size: 8px;', ...str);
}


/**
 * Time - Time format
 *
 * @return {String}  the time in xx:xx:xx format
 */
function time () {
    const now = new Date();

    return String(`${now.getHours()}:${now.getMinutes()}:${now.getSeconds()}`);
}



// WEBPACK FOOTER //
// ./lib/log.js